//Settings/Utils:
export const START_GET_TAGS = 'START_GET_TAGS';
export const GET_TAGS = 'GET_TAGS';
export const START_GET_SYSTEM_SETTINGS = 'START_GET_SYSTEM_SETTINGS';
export const GET_SYSTEM_SETTINGS = 'GET_SYSTEM_SETTINGS';
export const START_GET_PARTIAL_SYSTEM_SETTINGS = 'START_GET_PARTIAL_SYSTEM_SETTINGS';
export const GET_PARTIAL_SYSTEM_SETTINGS = 'GET_PARTIAL_SYSTEM_SETTINGS';
export const START_GET_PRINTERS = 'START_GET_PRINTERS';
export const GET_PRINTERS = 'GET_PRINTERS';

//Check Printing:
export const START_PRINT_CHECKS = 'START_PRINT_CHECKS';
export const PRINT_CHECKS_COMPLETED = 'PRINT_CHECKS_COMPLETED';
export const START_CONFIRM_CHECKS_PRINTED = 'START_CONFIRM_CHECKS_PRINTED';
export const CONFIRM_CHECKS_PRINTED = 'CONFIRM_CHECKS_PRINTED';

//Authentication: 
export const START_LOGIN = 'START_LOGIN';
export const LOGIN = 'LOGIN';
export const START_VERIFY_LOGIN = 'START_VERIFY_LOGIN';
export const VERIFY_LOGIN = 'VERIFY_LOGIN';
export const START_LOGOUT = 'START_LOGOUT';
export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const START_RECOVER_PASSWORD = 'START_RECOVER_PASSWORD';
export const RECOVER_PASSWORD = 'RECOVER_PASSWORD';
export const START_RESET_PASSWORD = 'START_RESET_PASSWORD';
export const RESET_PASSWORD = 'RESET_PASSWORD';

//Users:
export const START_GET_APPROVERS = 'START_GET_APPROVERS';
export const GET_APPROVERS = 'GET_APPROVERS';

export const UPDATE_USERS_TABLE = 'UPDATE_USERS_TABLE';
export const START_GET_USERS_TABLE_RECORDS = 'START_GET_USERS_TABLE_RECORDS';
export const GET_USERS_TABLE_RECORDS = 'GET_USERS_TABLE_RECORDS';
export const UPDATE_USERS_TABLE_RECORD = 'UPDATE_USERS_TABLE_RECORD';

export const START_GET_USER_DETAILS = 'START_GET_USER_DETAILS';
export const GET_USER_DETAILS = 'GET_USER_DETAILS';
export const START_GET_USER_PERMISSIONS = 'START_GET_USER_PERMISSIONS';
export const GET_USER_PERMISSIONS = 'GET_USER_PERMISSIONS';
export const CLEAR_USER_DETAILS_AND_PERMISSIONS = 'CLEAR_USER_DETAILS_AND_PERMISSIONS';

export const START_UPDATE_USER = 'START_UPDATE_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const START_UPDATE_USER_DETAIL = 'START_UPDATE_USER_DETAIL';
export const UPDATE_USER_DETAIL = 'UPDATE_USER_DETAIL';
export const START_CREATE_USER = 'START_CREATE_USER';
export const CREATE_USER = 'CREATE_USER';

export const START_GET_PERMISSIONS_FOR_ROLE = 'START_GET_PERMISSIONS_FOR_ROLE';
export const GET_PERMISSIONS_FOR_ROLE = 'GET_PERMISSIONS_FOR_ROLE';

//User Profile:
export const START_GET_USER_PROFILE = 'START_GET_USER_PROFILE';
export const GET_USER_PROFILE = 'GET_USER_PROFILE';
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';

//Suggestions:
export const START_GET_RECIPIENT_SUGGESTIONS = 'START_GET_RECIPIENT_SUGGESTIONS';
export const GET_RECIPIENT_SUGGESTIONS = 'GET_RECIPIENT_SUGGESTIONS';
export const CLEAR_RECIPIENT_SUGGESTIONS = 'CLEAR_RECIPIENT_SUGGESTIONS';

//Applications
export const START_GET_APPLICATION_STATUS_COUNTS = 'START_GET_APPLICATION_STATUS_COUNTS';
export const GET_APPLICATION_STATUS_COUNTS = 'GET_APPLICATION_STATUS_COUNTS';
export const START_GET_APPLICATIONS_TO_RECIPIENT_IDS_MAPPING = 'START_GET_APPLICATION_TO_RECIPIENT_ID_MAPPING';
export const GET_APPLICATIONS_TO_RECIPIENT_IDS_MAPPING = 'GET_APPLICATION_TO_RECIPIENT_ID_MAPPING';
export const UPDATE_APPLICATIONS_FILTERS = 'UPDATE_APPLICATIONS_FILTERS';
export const RESET_APPLICATIONS_FILTERS = 'RESET_APPLICATIONS_FILTERS';

export const UPDATE_APPLICATIONS_TABLE = 'UPDATE_APPLICATIONS_TABLE';
export const CLEAR_APPLICATIONS_TABLE_RECORDS = 'CLEAR_APPLICATIONS_TABLE_RECORDS';
export const START_GET_APPLICATIONS_TABLE_RECORDS = 'START_GET_APPLICATIONS_TABLE_RECORDS';
export const GET_APPLICATIONS_TABLE_RECORDS = 'GET_APPLICATIONS_TABLE_RECORDS';
export const START_UPDATE_APPLICATIONS_TABLE_RECORD = 'START_UPDATE_APPLICATIONS_TABLE_RECORD';
export const UPDATE_APPLICATIONS_TABLE_RECORD = 'UPDATE_APPLICATIONS_TABLE_RECORD';
export const START_REMOVE_APPLICATIONS_TABLE_RECORD = 'START_REMOVE_APPLICATIONS_TABLE_RECORD';
export const REMOVE_APPLICATIONS_TABLE_RECORD = 'REMOVE_APPLICATIONS_TABLE_RECORD';
export const TOGGLE_SELECT_APPLICATIONS_TABLE_RECORD = 'TOGGLE_SELECT_APPLICATIONS_TABLE_RECORD';
export const CLEAR_APPLICATIONS_TABLE_SELECTION = 'CLEAR_APPLICATIONS_TABLE_SELECTION';

export const START_UPDATE_APPLICATIONS_STATUS = 'START_UPDATE_APPLICATIONS_STATUS';
export const UPDATE_APPLICATIONS_STATUS_COMPLETED = 'UPDATE_APPLICATIONS_STATUS_COMPLETED';

export const START_VOID_APPLICATION_PAYMENT = 'START_VOID_APPLICATION_PAYMENT';
export const VOID_APPLICATION_PAYMENT_COMPLETED = 'VOID_APPLICATION_PAYMENT_COMPLETED';

export const START_SEND_ACH_APPLICATIONS = 'START_SEND_ACH_APPLICATIONS';
export const SEND_ACH_APPLICATIONS_COMPLETED = 'SEND_ACH_APPLICATIONS_COMPLETED';

export const UPDATE_SELECTED_COUNTS = 'UPDATE_SELECTED_COUNTS';

export const TOGGLE_APPLICATIONS_SIDEBAR_FILTERS = 'TOGGLE_APPLICATIONS_SIDEBAR_FILTERS';
export const UPDATE_APPLICATIONS_SIDEBAR_FILTERS = 'UPDATE_APPLICATIONS_SIDEBAR_FILTERS';
export const RESET_APPLICATIONS_SIDEBAR_FILTERS = 'RESET_APPLICATIONS_SIDEBAR_FILTERS';
export const SET_APPLICATIONS_APPLIED_FILTERS = 'SET_APPLICATIONS_APPLIED_FILTERS';

export const START_GET_APPLICATIONS_SAVED_SEARCHES = 'START_GET_APPLICATIONS_SAVED_SEARCHES';
export const GET_APPLICATIONS_SAVED_SEARCHES = 'GET_APPLICATIONS_SAVED_SEARCHES';
export const START_GET_APPLICATIONS_SAVED_SEARCH = 'START_GET_APPLICATIONS_SAVED_SEARCH';
export const GET_APPLICATIONS_SAVED_SEARCH = 'GET_APPLICATIONS_SAVED_SEARCH';
export const START_CREATE_APPLICATIONS_SAVED_SEARCH = 'START_CREATE_APPLICATIONS_SAVED_SEARCH';
export const CREATE_APPLICATIONS_SAVED_SEARCH = 'CREATE_APPLICATIONS_SAVED_SEARCH';
export const START_DELETE_APPLICATIONS_SAVED_SEARCH = 'START_DELETE_APPLICATIONS_SAVED_SEARCH';
export const DELETE_APPLICATIONS_SAVED_SEARCH = 'DELETE_APPLICATIONS_SAVED_SEARCH';

//Create Application:
export const START_CREATE_APPLICATION = 'START_CREATE_APPLICATION';
export const CREATE_APPLICATION = 'CREATE_APPLICATION';

//Recipients:
export const START_GET_ORGANIZATIONS = 'START_GET_ORGANIZATIONS';
export const GET_ORGANIZATIONS = 'GET_ORGANIZATIONS';

export const UPDATE_RECIPIENTS_FILTERS = 'UPDATE_RECIPIENTS_FILTERS';
export const RESET_RECIPIENTS_FILTERS = 'RESET_RECIPIENTS_FILTERS';

export const UPDATE_RECIPIENTS_TABLE = 'UPDATE_RECIPIENTS_TABLE';
export const START_GET_RECIPIENTS_TABLE_RECORDS = 'START_GET_RECIPIENTS_TABLE_RECORDS';
export const GET_RECIPIENTS_TABLE_RECORDS = 'GET_RECIPIENTS_TABLE_RECORDS';
export const GET_RECIPIENTS_FOR_EXPORT = 'GET_RECIPIENTS_FOR_EXPORT';
export const START_GET_PLEDGES_REPORT = 'START_GET_PLEDGES_REPORT';
export const GET_PLEDGES_REPORT = 'GET_PLEDGES_REPORT';
export const START_REMOVE_RECIPIENTS_TABLE_RECORD = 'START_REMOVE_RECIPIENTS_TABLE_RECORD';
export const REMOVE_RECIPIENTS_TABLE_RECORD = 'REMOVE_RECIPIENTS_TABLE_RECORD';
export const TOGGLE_SELECT_RECIPIENTS_TABLE_RECORD = 'TOGGLE_SELECT_RECIPIENTS_TABLE_RECORD';
export const CLEAR_RECIPIENTS_TABLE_SELECTION = 'CLEAR_RECIPIENTS_TABLE_SELECTION';

export const TOGGLE_RECIPIENTS_SIDEBAR_FILTERS = 'TOGGLE_RECIPIENTS_SIDEBAR_FILTERS';
export const UPDATE_RECIPIENTS_SIDEBAR_FILTERS = 'UPDATE_RECIPIENTS_SIDEBAR_FILTERS';
export const RESET_RECIPIENTS_SIDEBAR_FILTERS = 'RESET_RECIPIENTS_SIDEBAR_FILTERS';
export const SET_RECIPIENTS_APPLIED_FILTERS = 'SET_RECIPIENTS_APPLIED_FILTERS';

export const START_GET_RECIPIENTS_SAVED_SEARCHES = 'START_GET_RECIPIENTS_SAVED_SEARCHES';
export const GET_RECIPIENTS_SAVED_SEARCHES = 'GET_RECIPIENTS_SAVED_SEARCHES';
export const START_GET_RECIPIENTS_SAVED_SEARCH = 'START_GET_RECIPIENTS_SAVED_SEARCH';
export const GET_RECIPIENTS_SAVED_SEARCH = 'GET_RECIPIENTS_SAVED_SEARCH';
export const START_CREATE_RECIPIENTS_SAVED_SEARCH = 'START_CREATE_RECIPIENTS_SAVED_SEARCH';
export const CREATE_RECIPIENTS_SAVED_SEARCH = 'CREATE_RECIPIENTS_SAVED_SEARCH';
export const START_DELETE_RECIPIENTS_SAVED_SEARCH = 'START_DELETE_RECIPIENTS_SAVED_SEARCH';
export const DELETE_RECIPIENTS_SAVED_SEARCH = 'DELETE_RECIPIENTS_SAVED_SEARCH';

export const START_CREATE_RECIPIENT = 'START_CREATE_RECIPIENT';
export const CREATE_RECIPIENT = 'CREATE_RECIPIENT';

//Recipient Account Details:
export const START_GET_RECIPIENT_DETAILS = 'START_GET_RECIPIENT_DETAILS';
export const GET_RECIPIENT_DETAILS = 'GET_RECIPIENT_DETAILS';
export const START_GET_RECIPIENT_APPLICATION_HISTORY = 'START_GET_RECIPIENT_APPLICATION_HISTORY';
export const GET_RECIPIENT_APPLICATION_HISTORY = 'GET_RECIPIENT_APPLICATION_HISTORY';
export const GET_RECIPIENT_APPLICATIONS_FOR_EXPORT = 'GET_RECIPIENT_APPLICATIONS_FOR_EXPORT';

export const START_UPDATE_RECIPIENT_DETAILS = 'START_UPDATE_RECIPIENT_DETAILS';
export const UPDATE_RECIPIENT_DETAILS = 'UPDATE_RECIPIENT_DETAILS';

export const START_ADD_RECIPIENT_NOTE = 'START_ADD_RECIPIENT_NOTE';
export const ADD_RECIPIENT_NOTE = 'ADD_RECIPIENT_NOTE';
export const START_UPDATE_RECIPIENT_NOTE = 'START_UPDATE_RECIPIENT_NOTE';
export const UPDATE_RECIPIENT_NOTE = 'UPDATE_RECIPIENT_NOTE';
export const START_DELETE_RECIPIENT_NOTE = 'START_DELETE_RECIPIENT_NOTE';
export const DELETE_RECIPIENT_NOTE = 'DELETE_RECIPIENT_NOTE';

//Application Details:
export const START_GET_APPLICATION_DETAILS = 'START_GET_APPLICATION_DETAILS';
export const GET_APPLICATION_DETAILS = 'GET_APPLICATION_DETAILS';
export const UPDATE_APPLICATION_DETAILS = 'UPDATE_APPLICATION_DETAILS';

export const START_ADD_APPLICATION_NOTE = 'START_ADD_APPLICATION_NOTE';
export const ADD_APPLICATION_NOTE = 'ADD_APPLICATION_NOTE';
export const START_UPDATE_APPLICATION_NOTE = 'START_UPDATE_APPLICATION_NOTE';
export const UPDATE_APPLICATION_NOTE = 'UPDATE_APPLICATION_NOTE';
export const START_DELETE_APPLICATION_NOTE = 'START_DELETE_APPLICATION_NOTE';
export const DELETE_APPLICATION_NOTE = 'DELETE_APPLICATION_NOTE';

export const START_UPDATE_APPLICATION_ATTACHMENTS = 'START_UPDATE_APPLICATION_ATTACHMENTS';
export const UPDATE_APPLICATION_ATTACHMENTS = 'UPDATE_APPLICATION_ATTACHMENTS';

export const START_UPDATE_APPLICATION_RECEIPTS = 'START_UPDATE_APPLICATION_RECEIPTS';
export const UPDATE_APPLICATION_RECEIPTS = 'UPDATE_APPLICATION_RECEIPTS';

export const START_UPDATE_APPLICATION = 'START_UPDATE_APPLICATION';
export const UPDATE_APPLICATION = 'UPDATE_APPLICATION';

//References:
export const START_GET_REFERENCES = 'START_GET_REFERENCES';
export const GET_REFERENCES = 'GET_REFERENCES';

export const UPDATE_REFERENCES_SEARCH = 'UPDATE_REFERENCES_SEARCH';
export const START_CREATE_REFERENCE = 'START_CREATE_REFERENCE';
export const CREATE_REFERENCE = 'CREATE_REFERENCE';
export const START_UPDATE_REFERENCE = 'START_UPDATE_REFERENCE';
export const UPDATE_REFERENCE = 'UPDATE_REFERENCE'; 

export const UPDATE_REFERENCES_TABLE = 'UPDATE_REFERENCES_TABLE';
export const START_GET_REFERENCES_TABLE_RECORDS = 'START_GET_REFERENCES_TABLE_RECORDS';
export const GET_REFERENCES_TABLE_RECORDS = 'GET_REFERENCES_TABLE_RECORDS';
export const START_REMOVE_REFERENCES_TABLE_RECORD = 'START_REMOVE_REFERENCES_TABLE_RECORD';
export const REMOVE_REFERENCES_TABLE_RECORD = 'REMOVE_REFERENCES_TABLE_RECORD';

//Duplicate Recipients:
export const START_FIND_DUPLICATE_RECIPIENTS = 'START_FIND_DUPLICATE_RECIPIENTS';
export const FIND_DUPLICATE_RECIPIENTS_COMPLETE = 'FIND_DUPLICATE_RECIPIENTS_COMPLETE';

export const UPDATE_DUPLICATE_RECIPIENTS_TABLE = 'UPDATE_DUPLICATE_RECIPIENTS_TABLE';
export const START_GET_DUPLICATE_RECIPIENTS_TABLE_RECORDS = 'START_GET_DUPLICATE_RECIPIENTS_TABLE_RECORDS';
export const GET_DUPLICATE_RECIPIENTS_TABLE_RECORDS = 'GET_DUPLICATE_RECIPIENTS_TABLE_RECORDS';

export const START_GET_DUPLICATE_RECIPIENTS_DETAILS = 'START_GET_DUPLICATE_RECIPIENTS_DETAILS';
export const GET_DUPLICATE_RECIPIENTS_DETAILS = 'GET_DUPLICATE_RECIPIENTS_DETAILS';
export const START_RESOLVE_DUPLICATE_RECIPIENTS = 'START_RESOLVE_DUPLICATE_RECIPIENTS';
export const RESOLVE_DUPLICATE_RECIPIENTS = 'RESOLVE_DUPLICATE_RECIPIENTS';

//Campaigns:
export const START_GET_CAMPAIGNS = 'START_GET_CAMPAIGNS';
export const GET_CAMPAIGNS = 'GET_CAMPAIGNS';

export const UPDATE_CAMPAIGNS_FILTERS = 'UPDATE_CAMPAIGNS_FILTERS';
export const START_CREATE_CAMPAIGN = 'START_CREATE_CAMPAIGN';
export const CREATE_CAMPAIGN = 'CREATE_CAMPAIGN';
export const DELETE_CAMPAIGN = 'DELETE_CAMPAIGN';

export const UPDATE_CAMPAIGNS_TABLE = 'UPDATE_CAMPAIGNS_TABLE';
export const START_GET_CAMPAIGNS_TABLE_RECORDS = 'START_GET_CAMPAIGNS_TABLE_RECORDS';
export const GET_CAMPAIGNS_TABLE_RECORDS = 'GET_CAMPAIGNS_TABLE_RECORDS';

//Campaign Details:
export const START_GET_CAMPAIGN_DETAILS = 'START_GET_CAMPAIGN_DETAILS';
export const GET_CAMPAIGN_DETAILS = 'GET_CAMPAIGN_DETAILS';
export const CLEAR_CAMPAIGN_DETAILS = 'CLEAR_CAMPAIGN_DETAILS';
export const START_UPDATE_CAMPAIGN_DETAILS = 'START_UPDATE_CAMPAIGN_DETAILS';
export const UPDATE_CAMPAIGN_DETAILS = 'UPDATE_CAMPAIGN_DETAILS';

export const START_GET_CAMPAIGN_ALL_LISTS = 'START_GET_CAMPAIGN_ALL_LISTS';
export const GET_CAMPAIGN_ALL_LISTS = 'GET_CAMPAIGN_ALL_LISTS';
export const START_GET_CAMPAIGN_ALL_INDIVIDUALS= 'START_GET_CAMPAIGN_ALL_INDIVIDUALS';
export const GET_CAMPAIGN_ALL_INDIVIDUALS = 'GET_CAMPAIGN_ALL_INDIVIDUALS';

export const UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE = 'UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE';
export const START_GET_CAMPAIGN_DETAILS_LISTS_TABLE_RECORDS = 'START_GET_CAMPAIGN_DETAILS_LISTS_TABLE_RECORDS';
export const GET_CAMPAIGN_DETAILS_LISTS_TABLE_RECORDS = 'GET_CAMPAIGN_DETAILS_LISTS_TABLE_RECORDS';
export const START_UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD = 'START_UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD';
export const UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD = 'UPDATE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD';
export const START_REMOVE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD = 'START_REMOVE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD';
export const REMOVE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD = 'REMOVE_CAMPAIGN_DETAILS_LISTS_TABLE_RECORD';
export const CLEAR_CAMPAIGN_DETAILS_LISTS_TABLE_RECORDS = 'CLEAR_CAMPAIGN_DETAILS_LISTS_TABLE_RECORDS';

export const START_GET_ALL_CAMPAIGN_LISTS = 'START_GET_ALL_CAMPAIGN_LISTS';
export const GET_ALL_CAMPAIGN_LISTS = 'GET_ALL_CAMPAIGN_LISTS';
export const START_ADD_CAMPAIGN_DETAILS_LIST = 'START_ADD_CAMPAIGN_DETAILS_LIST';
export const ADD_CAMPAIGN_DETAILS_LIST = 'ADD_CAMPAIGN_DETAILS_LIST';
export const START_APPROVE_CAMPAIGN_DETAILS_LIST = 'START_APPROVE_CAMPAIGN_DETAILS_LIST';
export const APPROVE_CAMPAIGN_DETAILS_LIST = 'APPROVE_CAMPAIGN_DETAILS_LIST';
export const START_RESEND_CAMPAIGN_DETAILS_LIST = 'START_RESEND_CAMPAIGN_DETAILS_LIST';
export const RESEND_CAMPAIGN_DETAILS_LIST = 'RESEND_CAMPAIGN_DETAILS_LIST';
export const START_GET_CAMPAIGN_LIST_EXTERNAL_UPDATES = 'START_GET_CAMPAIGN_LIST_EXTERNAL_UPDATES';
export const GET_CAMPAIGN_LIST_EXTERNAL_UPDATES = 'GET_CAMPAIGN_LIST_EXTERNAL_UPDATES';
export const START_VERIFY_CAMPAIGN_LIST_EXTERNAL_UPDATES = 'START_VERIFY_CAMPAIGN_LIST_EXTERNAL_UPDATES';
export const VERIFY_CAMPAIGN_LIST_EXTERNAL_UPDATES = 'VERIFY_CAMPAIGN_LIST_EXTERNAL_UPDATES';

export const UPDATE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE = 'UPDATE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE';
export const START_GET_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORDS = 'START_GET_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORDS';
export const GET_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORDS = 'GET_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORDS';
export const START_UPDATE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD = 'START_UPDATE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD';
export const UPDATE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD = 'UPDATE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD';
export const START_REMOVE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD = 'START_REMOVE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD';
export const REMOVE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD = 'REMOVE_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD';
export const TOGGLE_SELECT_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD = 'TOGGLE_SELECT_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORD';
export const CLEAR_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_SELECTION = 'CLEAR_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_SELECTION';
export const CLEAR_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORDS = 'CLEAR_CAMPAIGN_DETAILS_INDIVIDUALS_TABLE_RECORDS';

export const START_ADD_CAMPAIGN_DETAILS_INDIVIDUAL = 'START_ADD_CAMPAIGN_DETAILS_INDIVIDUAL';
export const ADD_CAMPAIGN_DETAILS_INDIVIDUAL = 'ADD_CAMPAIGN_DETAILS_INDIVIDUAL';

//Campaign Lists:
export const UPDATE_CAMPAIGN_LISTS_FILTERS = 'UPDATE_CAMPAIGN_LISTS_FILTERS';
export const START_CREATE_CAMPAIGN_LIST = 'START_CREATE_CAMPAIGN_LIST';
export const CREATE_CAMPAIGN_LIST = 'CREATE_CAMPAIGN_LIST';

export const UPDATE_CAMPAIGN_LISTS_SEARCH = 'UPDATE_CAMPAIGN_LISTS_SEARCH';
export const START_GET_CAMPAIGN_LISTS = 'START_GET_CAMPAIGN_LISTS';
export const GET_CAMPAIGN_LISTS = 'GET_CAMPAIGN_LISTS';

export const UPDATE_CAMPAIGN_LISTS_TABLE = 'UPDATE_CAMPAIGN_LISTS_TABLE';
export const START_GET_CAMPAIGN_LISTS_TABLE_RECORDS = 'START_CREATE_CAMPAIGN_LIST_TABLE_RECORDS';
export const GET_CAMPAIGN_LISTS_TABLE_RECORDS = 'GET_CAMPAIGN_LISTS_TABLE_RECORDS';

//Campaign List Details:
export const START_GET_CAMPAIGN_LIST_DETAILS = 'START_GET_CAMPAIGN_LIST_DETAILS';
export const GET_CAMPAIGN_LIST_DETAILS = 'GET_CAMPAIGN_LIST_DETAILS';
export const CLEAR_CAMPAIGN_LIST_DETAILS = 'CLEAR_CAMPAIGN_LIST_DETAILS';
export const START_UPDATE_CAMPAIGN_LIST_DETAILS = 'START_UPDATE_CAMPAIGN_LIST_DETAILS';
export const UPDATE_CAMPAIGN_LIST_DETAILS = 'UPDATE_CAMPAIGN_LIST_DETAILS';
export const START_ADD_CAMPAIGN_LIST_PARTICIPANT = 'START_ADD_CAMPAIGN_LIST_PARTICIPANT';
export const ADD_CAMPAIGN_LIST_PARTICIPANT = 'ADD_CAMPAIGN_LIST_PARTICIPANT';
export const START_GET_CAMPAIGN_LIST_ALL_PARTICIPANTS = 'START_GET_CAMPAIGN_LIST_ALL_PARTICIPANTS';
export const GET_CAMPAIGN_LIST_ALL_PARTICIPANTS = 'GET_CAMPAIGN_LIST_ALL_PARTICIPANTS';

export const UPDATE_CAMPAIGN_LIST_PARTICIPANTS_TABLE = 'UPDATE_CAMPAIGN_LIST_PARTICIPANTS_TABLE';
export const START_GET_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORDS = 'START_GET_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORDS';
export const GET_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORDS = 'GET_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORDS';
export const START_REMOVE_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORD = 'START_REMOVE_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORD';
export const REMOVE_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORD = 'REMOVE_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORD';
export const CLEAR_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORDS = 'CLEAR_CAMPAIGN_LIST_PARTICIPANTS_TABLE_RECORDS';

export const START_GET_CAMPAIGN_LIST_PENDING_PARTICIPANTS = 'START_GET_CAMPAIGN_LIST_PENDING_PARTICIPANTS';
export const GET_CAMPAIGN_LIST_PENDING_PARTICIPANTS = 'GET_CAMPAIGN_LIST_PENDING_PARTICIPANTS';

//Campaign List Applications:
export const UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE = 'UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE';
export const START_GET_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORDS = 'START_GET_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORDS';
export const GET_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORDS = 'GET_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORDS';
export const START_UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORD = 'START_UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORD';
export const UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORD = 'UPDATE_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORD';
export const CLEAR_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORDS = 'CLEAR_CAMPAIGN_LIST_APPLICATIONS_TABLE_RECORDS';

export const UPDATE_CAMPAIGN_LISTS_APPLICATIONS_STATUS = 'UPDATE_CAMPAIGN_LIST_APPLICATIONS_STATUS';
export const CLEAR_CAMPAIGN_LISTS_APPLICATIONS_STATUS = 'CLEAR_CAMPAIGN_LIST_APPLICATIONS_STATUS';

//Receiving Participants (verify)
export const UPDATE_RECEIVING_PARTICIPANTS_INFINITELIST_CONFIGS = 'UPDATE_RECEIVING_PARTICIPANTS_CONFIGS';
export const START_GET_RECEIVING_PARTICIPANTS_INFINITELIST_RECORDS = 'START_GET_RECEIVING_PARTICIPANTS_RECORDS';
export const GET_RECEIVING_PARTICIPANTS_INFINITELIST_RECORDS = 'GET_RECEIVING_PARTICIPANTS_INFINITELIST_RECORDS';
export const CLEAR_RECEIVING_PARTICIPANTS_INFINITELIST_RECORDS = 'CLEAR_RECEIVING_PARTICIPANTS_INFINITELIST_RECORDS';

//EXTERNAL CAMPAIGN LISTS
export const START_GET_EXTERNAL_CAMPAIGN_LIST_DETAILS = 'START_GET_EXTERNAL_CAMPAIGN_LIST_DETAILS';
export const GET_EXTERNAL_CAMPAIGN_LIST_DETAILS = 'GET_EXTERNAL_CAMPAIGN_LIST_DETAILS';

export const START_GET_EXTERNAL_CAMPAIGN_LIST_RECIPIENTS = 'START_GET_EXTERNAL_CAMPAIGN_LIST_RECIPIENTS';
export const GET_EXTERNAL_CAMPAIGN_LIST_RECIPIENTS = 'GET_EXTERNAL_CAMPAIGN_LIST_RECIPIENTS';

export const UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS_INFINITELIST_CONFIGS = 'UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS_INFINITELIST_CONFIGS';
export const START_GET_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS_INFINITELIST_RECORDS = 'START_GET_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS_INFINITELIST_RECORDS';
export const GET_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS_INFINITELIST_RECORDS = 'GET_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS_INFINITELIST_RECORDS';
export const UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS_INFINITELIST_DATA = 'UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS_INFINITELIST_DATA';

export const START_UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS = 'START_UDPATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS';
export const UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS = 'UPDATE_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS';
export const START_SELECT_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS = 'START_SELECT_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS';
export const SELECT_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS = 'SELECT_EXTERNAL_CAMPAIGN_LIST_PARTICIPANTS';

export const START_EXPORT_EXTERNAL_CAMPAIGN_LIST = 'START_EXPORT_EXTERNAL_CAMPAIGN_LIST';
export const EXPORT_EXTERNAL_CAMPAIGN_LIST = 'EXPORT_EXTERNAL_CAMPAIGN_LIST';
export const START_SUBMIT_EXTERNAL_CAMPAIGN_LIST = 'START_SUBMIT_EXTERNAL_CAMPAIGN_LIST';
export const SUBMIT_EXTERNAL_CAMPAIGN_LIST = 'SUBMIT_EXTERNAL_CAMPAIGN_LIST';

//SYSTEM SETTINGS (editing)
export const START_ADD_TAG = 'START_ADD_TAG';
export const ADD_TAG = 'ADD_TAG'
export const START_UPDATE_TAG = 'START_UPDATE_TAG';
export const UPDATE_TAG = 'UPDATE_TAG'
export const START_DELETE_TAG = "START_DELETE_TAG";
export const DELETE_TAG = "DELETE_TAG";

export const START_UPDATE_SETTING = "START_UPDATE_SETTING";
export const UPDATE_SETTING = "UPDATE_SETTING";

export const START_ADD_SIGNATURE = 'START_ADD_SIGNATURE';
export const ADD_SIGNATURE = 'ADD_SIGNATURE';

//FUNDS - ACCOUNTING
export const START_GET_FUNDS = 'START_GET_FUNDS';
export const GET_FUNDS = 'GET_FUNDS';

export const START_GET_FUNDS_VERBOSE = 'START_GET_FUNDS_VERBOSE';
export const GET_FUNDS_VERBOSE = 'GET_FUNDS_VERBOSE';

export const START_CREATE_FUND = 'START_CREATE_FUND';
export const CREATE_FUND = 'CREATE_FUND';

export const START_GET_FUND_DETAILS = 'START_GET_FUND_DETAILS';
export const GET_FUND_DETAILS = 'GET_FUND_DETAILS';

export const START_UPDATE_FUND = 'START_UPDATE_FUND';
export const UPDATE_FUND = 'UPDATE_FUND';

export const UPDATE_ACCOUNTING_FILTERS = 'UPDATE_ACCOUNTING_FILTERS';

export const UPDATE_ACCOUNTING_TRANSACTIONS_TABLE = 'UPDATE_ACCOUNTING_TRANSACTIONS_TABLE';
export const START_GET_ACCOUNTING_TRANSACTIONS_TABLE_RECORDS = 'START_GET_ACCOUNTING_TRANSACTIONS_TABLE_RECORDS';
export const GET_ACCOUNTING_TRANSACTIONS_TABLE_RECORDS = 'GET_ACCOUNTING_TRANSACTIONS_TABLE_RECORDS';
export const CLEAR_ACCOUNTING_TRANSACTIONS_TABLE_RECORDS = 'CLEAR_ACCOUNTING_TRANSACTIONS_TABLE_RECORDS';

export const UPDATE_ACCOUNTING_OUTSIDE_TRANSACTION_FILTERS = 'UPDATE_ACCOUNTING_OUTSIDE_TRANSACTION_FILTERS';
export const UPDATE_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE = 'UPDATE_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE';
export const START_GET_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE_RECORDS = 'START_GET_ACCOUNTING__OUTSIDE_TRANSACTIONS_TABLE_RECORDS';
export const GET_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE_RECORDS = 'GET_ACCOUNTING_TRANSACTIONS_OUTSIDE_TABLE_RECORDS';
export const CLEAR_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE_RECORDS = 'CLEAR_ACCOUNTING_OUTSIDE_TRANSACTIONS_TABLE_RECORDS';

export const START_CREATE_OUTSIDE_TRANSACTION = 'START_CREATE_OUTSIDE_TRANSACTION';
export const CREATE_OUTSIDE_TRANSACTION = 'CREATE_OUTSIDE_TRANSACTION';
export const START_UPDATE_TRANSACTION = 'START_UPDATE_TRANSACTION';
export const UPDATE_TRANSACTION = 'UPDATE_TRANSACTION';
export const START_VOIDING_TRANSACTION = 'START_VOIDING_TRANSACTION';
export const VOID_TRANSACTIONS = 'VOID_TRANSACTIONS';

export const START_GET_BANK_RECONCILIATIONS = 'START_GET_BANK_RECONCILIATIONS';
export const GET_BANK_RECONCILIATIONS = 'GET_BANK_RECONCILIATIONS';

export const START_DELETE_RECONCILIATION_REPORT = 'START_DELETE_RECONCILIATION_REPORT';
export const DELETE_RECONCILIATION_REPORT = 'DELETE_RECONCILIATION_REPORT';

export const UPDATE_RECONCILIATION_REPORTS_FILTERS = 'UPDATE_RECONCILIATION_REPORTS_FILTERS';

export const UPDATE_RECONCILIATION_PAYMENTS_INFINITELIST_CONFIGS = 'UPDATE_RECONCILIATION_PAYMENTS_INFINITELIST_CONFIGS';
export const START_GET_RECONCILIATION_PAYMENTS_INFINITELIST_RECORDS = 'START_GET_RECONCILIATION_PAYMENTS_INFINITELIST_RECORDS';
export const GET_RECONCILIATION_PAYMENTS_INFINITELIST_RECORDS = 'GET_RECONCILIATION_PAYMENTS_INFINITELIST_RECORDS';
export const TOGGLE_SELECT_RECONCILIATION_PAYMENTS_INFINITELIST_RECORD = 'TOGGLE_SELECT_RECONCILIATION_PAYMENTS_INFINITELIST_RECORD';
export const CLEAR_RECONCILIATION_PAYMENTS_INFINITELIST_SELECTION = 'CLEAR_RECONCILIATION_PAYMENTS_INFINITELIST_SELECTION';
export const CLEAR_RECONCILIATION_PAYMENTS_INFINITELIST_RECORDS = 'CLEAR_RECONCILIATION_PAYMENTS_INFINITELIST_RECORDS';

export const UPDATE_RECONCILIATION_CREDITS_INFINITELIST_CONFIGS = 'UPDATE_RECONCILIATION_CREDITS_INFINITELIST_CONFIGS';
export const START_GET_RECONCILIATION_CREDITS_INFINITELIST_RECORDS = 'START_GET_RECONCILIATION_CREDITS_INFINITELIST_RECORDS';
export const GET_RECONCILIATION_CREDITS_INFINITELIST_RECORDS = 'GET_RECONCILIATION_CREDITS_INFINITELIST_RECORDS';
export const TOGGLE_SELECT_RECONCILIATION_CREDITS_INFINITELIST_RECORD = 'TOGGLE_SELECT_RECONCILIATION_CREDITS_INFINITELIST_RECORD';
export const CLEAR_RECONCILIATION_CREDITS_INFINITELIST_SELECTION = 'CLEAR_RECONCILIATION_CREDITS_INFINITELIST_SELECTION';
export const CLEAR_RECONCILIATION_CREDITS_INFINITELIST_RECORDS = 'CLEAR_RECONCILIATION_CREDITS_INFINITELIST_RECORDS';

export const UPDATE_RECONCILIATION_ADJUSTMENTS = 'UPDATE_RECONCILIATION_ADJUSTMENTS';
export const UPDATE_RECONCILIATION_BALANCE = 'UPDATE_RECONCILIATION_BALANCE';

export const START_GET_RECONCILIATION_REPORT = 'START_GET_RECONCILIATION_REPORT';
export const GET_RECONCILIATION_REPORT = 'GET_RECONCILIATION_REPORT';
export const START_CREATE_RECONCILIATION_REPORT = 'START_CREATE_RECONCILIATION_REPORT';
export const CREATE_RECONCILIATION_REPORT = 'CREATE_RECONCILIATION_REPORT';
export const START_CREATE_AND_COMPLETE_RECONCILIATION_REPORT = 'START_CREATE_AND_COMPLETE_RECONCILIATION_REPORT';
export const CREATE_AND_COMPLETE_RECONCILIATION_REPORT = 'CREATE_AND_COMPLETE_RECONCILIATION_REPORT';
export const START_UPDATE_RECONCILIATION_REPORT = 'START_UPDATE_RECONCILIATION_REPORT';
export const UPDATE_RECONCILIATION_REPORT = 'UPDATE_RECONCILIATION_REPORT';
export const START_COMPLETE_RECONCILIATION_REPORT = 'START_COMPLETE_RECONCILIATION_REPORT';
export const COMPLETE_RECONCILIATION_REPORT = 'COMPLETE_RECONCILIATION_REPORT';

export const START_GET_BLANK_CHECKS = 'START_GET_BLANK_CHECKS';
export const GET_BLANK_CHECKS = 'GET_BLANK_CHECKS';
export const CLEAR_BLANK_CHECKS = 'CLEAR_BLANK_CHECKS';

//LANGUAGE SETTINGS
export const UPDATE_GEOSUGGEST_SETTINGS = 'UPDATE_GEOSUGGEST_SETTINGS';



// WEBPACK FOOTER //
// ./src/redux/actions/actionTypes.js